'use strict';

(function () {

  angular.module('specsguardApp')
    .config(BasicAreasConfig);

  BasicAreasConfig.$inject = ['$stateProvider'];

  function BasicAreasConfig ($stateProvider) {
    $stateProvider

      .state('project/basic-areas', {
        url: '/project/{project_id}/basic-areas',
        templateUrl: 'app-legacy/project/basic-areas/basic.areas.html',
        controller: 'ProjectBasicAreasCtrl',
        controllerAs: 'BasicAreasCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Ruimte template overzicht]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: [['basicarea']]
            }
          }
        ],
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      });
  }
})();
